// extracted by mini-css-extract-plugin
export default {"container":"VG1y8c","responsive":"GPOjrF"};